/**
 * Utility functions for checking cookies
 */

// Entry-gateway session-manager cookie
export const UNIFIED_SESSION_MANAGER_COOKIE = 'unified-session-manager-cookie';

// Login session cookie
export const LOGIN_SESSION_COOKIE = 'login-session';

// Global session cookie
export const GSSC_COOKIE = 'cb-gssc_development';

/**
 * Get a cookie by name
 */
export function getCookie(name: string): string {
  if (typeof document === 'undefined') return '';

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() ?? '';
  return '';
}

/**
 * Clear a cookie by name
 */
export function clearCookie(name: string) {
  if (typeof document === 'undefined') return;

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
